module.exports = __webpack_public_path__ + "media/images/spree/frontend/panels/product/ponsonby-428b1f53384924c13ea9cd9065b3726d.jpg";